import { render, staticRenderFns } from "./AssignUserAreas.vue?vue&type=template&id=4a1a1592&"
import script from "./AssignUserAreas.vue?vue&type=script&lang=js&"
export * from "./AssignUserAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports